import { map, type LatLng } from 'leaflet';
import { useState } from 'react';
import {
	MapContainer,
	Marker,
	Popup,
	TileLayer,
	useMap,
	useMapEvents,
} from 'react-leaflet';

type MapProps = {
	children: React.ReactNode;
	center?: [number, number];
	zoom?: number;
};

export function Map(props: MapProps) {
	const [position, setPosition] = useState<LatLng | null>(null);
	const center = props.center || [-23.5618093, -46.6376547];
	const zoom = props.zoom || 12.5;

	function LocationMarker() {
		const map = useMapEvents({
			click() {
				map.locate();
			},
			locationfound(e) {
				setPosition(e.latlng);
				map.flyTo(e.latlng, map.getZoom(), {
					animate: true,
					duration: 0.2,
				});
			},
		});

		return <></>;
	}
	return (
		<MapContainer
			center={center}
			zoom={zoom}
			scrollWheelZoom={true}
			className="map"
		>
			<TileLayer
				url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
				attribution='<a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
			/>
			{props.children}
			<LocationMarker />
		</MapContainer>
	);
}
